import { Fragment, type FunctionComponent } from "react";
import { FAQ } from "@App/Components/common/FAQ";
import { FAQItem } from "@App/Components/common/FAQItem";
import { useSelector } from "react-redux";
import { State } from "@App/state";

type ServiceFAQsProps = {
  sidebar?: boolean;
};

export const ServiceFAQs: FunctionComponent<ServiceFAQsProps> = ({ sidebar }: ServiceFAQsProps) => {
  const service = useSelector((state: State) => state.orders.service);

  return (
    <Fragment>
      {service && service.pivot.faqs.length > 0 && (
        <FAQ sidebar={sidebar}>
          {service.pivot.faqs.map((faq) => (
            <FAQItem key={faq.headline} title={faq.headline} compact={sidebar}>
              <div dangerouslySetInnerHTML={{ __html: faq.content }} />
            </FAQItem>
          ))}
        </FAQ>
      )}
    </Fragment>
  );
};
